/** TODO: implement Remove request pattern */
export default () => null;
